var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTtQrFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 828 1132",
    width: 828,
    height: 1132,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TT-etikett-73-100-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 596.1h13.1v-13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 569.89h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 556.79h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 583h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 569.89h13.11v13.11h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 556.79h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.3 583h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.3 569.89h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.3 556.79h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.08 530.57h91.74v91.74h-91.74zm13.11 78.63h65.53v-65.53h-65.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570.83 294.67h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570.83 281.56h13.11v13.11h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570.83 268.46h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m557.73 294.67h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m557.73 281.56h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m557.73 268.46h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m544.62 294.67h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m544.62 281.56h13.11v13.11h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m544.62 268.46h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m610.15 333.99h-91.74v-91.74h91.74zm-13.1-78.64h-65.53v65.53h65.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 294.67h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 281.56h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 268.46h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 294.67h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 281.56h13.11v13.11h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 268.46h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.3 281.56h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.3 294.67h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 596.08h13.1v-13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 569.87h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 556.76h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 582.98h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 569.87h13.11v13.11h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 556.76h13.11v13.11h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.3 582.98h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.3 569.87h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.3 556.76h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.08 530.55h91.74v91.74h-91.74zm13.11 78.63h65.53v-65.53h-65.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570.83 294.65h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570.83 281.54h13.11v13.11h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570.83 268.44h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m557.73 294.65h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m557.73 281.54h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m557.73 268.44h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m544.62 294.65h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m544.62 281.54h13.11v13.11h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m544.62 268.44h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m610.15 333.96h-91.74v-91.74h91.74zm-13.1-78.63h-65.53v65.53h65.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 294.65h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 281.54h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.51 268.44h13.1v13.1h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 294.65h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 281.54h13.11v13.11h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m269.4 268.44h13.11v13.1h-13.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.3 281.54h13.1v13.11h-13.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.3 294.65h13.1v13.1h-13.1z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #1fbbc3 } \n\t\t.s1 { fill: #e9eae9 } \n\t\t.s2 { fill: #e8eae8 } \n\t\t.s3 { fill: #020505 } \n\t\t.s4 { fill: #000001 } \n\t\t.s5 { fill: #231f20 } \n\t\t.s6 { fill: #111517 } \n\t\t.s7 { fill: none } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m440.8 1114.8c198.8 0 359.9-161.2 359.9-360v-362.5h-770.3v362.5c0 198.8 161.2 360 360 360z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m79.3 750.3l31.9-5 1.4 8.6-31.6 5c-6.9 1.1-9.3 6.2-8.4 11.4 0.8 5.1 4.5 9.2 11.5 8.1l31.6-4.9 1.3 8.6-31.9 5.1c-11.2 1.7-19.2-5.8-20.8-15.6-1.6-9.9 3.8-19.6 15-21.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m82.4 838.5l13.2-17.4-1.4-4.2-17.2 5.7-2.8-8.3 47-15.8 6.2 18.4c3.6 10.5-2.5 17.5-10 20-6.8 2.3-15.1 0.2-18.4-6.7l-13.3 18.1zm34.2-29.2l-15.4 5.2 2.8 8.4c2 5.9 6.2 7.2 10.4 5.8 4.3-1.5 6.9-5.3 5.4-9.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m106.1 859.3l4 7.7c-3.4 1.8-4.9 6.7-2.3 11.6 2.3 4.4 6.5 5.9 10 4.1 3.1-1.6 3.5-5.2 2.6-9.4l-1.4-6.3c-2.5-10.7 2.3-15.3 6.2-17.3 7.8-4.1 16.6 0 20.8 8.1 4.2 8 2.6 16.9-5.7 21.2l-4-7.7c3.6-1.9 4.8-6 2.7-10.1-2-3.7-6.2-5.5-9.6-3.7-1.2 0.6-3.6 2.3-2.3 8.1l1.2 6c1.7 7.9 0.9 15-6.1 18.7-8.1 4.2-16.9 0.3-21.4-8.3-4.9-9.4-2.2-18.9 5.3-22.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m173.2 902.3c6.5 8.8 2.8 17.3-3.6 22-6.4 4.8-15.5 5.7-22-3.1l-6.7-9.1-14.3 10.5-5.2-7 39.9-29.5zm-19.5 13.9c3.1 4.1 7.5 3.5 10.7 1.1 3.2-2.3 5.3-6.4 2.3-10.5l-6.5-8.9-13 9.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m174.9 978.1l4-21.4-3.2-3.2-12.7 12.9-6.2-6.1 34.7-35.4 13.9 13.6c7.9 7.8 5.6 16.8 0.1 22.4-5 5.1-13.4 6.9-19.5 2.4l-3.7 22.1zm17.4-41.5l-11.4 11.6 6.3 6.2c4.4 4.4 8.7 3.7 11.9 0.4 3.2-3.2 3.7-7.8 0.3-11.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m209.1 985.2l18.6-26.5 7.1 5.1-18.3 26.1c-4 5.8-2 11 2.3 14 4.3 3 9.9 3.2 13.9-2.6l18.4-26.2 7.2 5-18.6 26.5c-6.5 9.3-17.5 9.9-25.6 4.2-8.2-5.7-11.5-16.3-5-25.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m298 1000.3l7.9 3.7-21 44.9-7.2-3.3-3.8-38.7-14.1 30.3-8-3.8 21-44.9 7.5 3.6 3.7 38.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m312.6 1033.4c3.5-13.7 17.2-22.2 30.9-18.6 6.9 1.8 12.3 6.2 15.4 11.7l-7.6 3.7c-2.1-3.6-5.5-6.4-9.8-7.5-9-2.4-17.9 3.6-20.3 12.9-2.4 9.1 2.3 18.8 11.5 21.2 7.1 1.9 14.9-1 16.5-7.2l-13.7-3.6 1.8-7.1 23 6c-4.6 17.5-16.1 23.1-29.4 19.6-14.2-3.7-21.8-17.6-18.3-31.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m442 1067.5l0.1 7.5-1.8 0.1c-5.4 0-9.3-2.1-10.9-5.8-2.5 4-7.6 6.5-13.5 6.6-9.5 0.1-15.6-5.7-15.8-14.1-0.1-6.6 3.9-11.5 8.7-13.4-3.5-1.3-6-5.5-6.1-10.4-0.1-7.5 5.7-13.3 14.2-13.5 5.2 0 9.9 2.3 12.6 6l-5.9 5.2c-1.3-2.1-3.8-3.4-6.4-3.4-3.5 0.1-6.2 2.6-6.2 6.2 0.1 3.9 3 6.7 7.9 6.6l7.5-0.1-0.1-5.3 7.9-0.1 0.1 5.4 6.1-0.1 0.1 6.5-6.1 0.1 0.2 7.7c0 5.3 2.5 8.4 5.9 8.4zm-15.4-9l-0.1-7-7.2 0.1c-6.6 0.2-10.9 3.8-10.8 9 0.1 4.6 3.4 7.5 8.3 7.4 5.9-0.1 9.8-3.9 9.8-9.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m488 1068.7l-9.8-48.6 8.6-1.7 9.8 48.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m522.7 1008.2c13.4-4.6 24.8 2.9 29.4 16.2 4.6 13.2 0.3 26-13.1 30.7l-18.4 6.3-16.2-46.8zm13.7 39.4c8.5-2.9 10.3-11.6 7.3-20.3-3.1-8.8-10-14.6-18.5-11.7l-10 3.5 11.1 32z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m584.7 1026.7l19.7-10.7 3.7 6.8-27.3 15-23.8-43.5 26.7-14.6 3.8 6.9-19.1 10.4 6.4 11.7 16.7-9.1 3.8 7-16.6 9.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m618.7 954.2l7-5.4 30.4 39.1-6.3 4.9-36.1-14.2 20.5 26.4-6.9 5.4-30.5-39.1 6.6-5.1 35.7 14.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m660.3 913.2l5.8 5.3-9.7 10.4 30.5 28.5-6 6.4-30.5-28.5-9.7 10.4-5.7-5.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m708.2 931.7l-39.9-29.4 5.2-7.1 39.9 29.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m699.9 852.2l6.8 3.9-7 12.3 36.2 20.6-4.3 7.7-36.3-20.7-7 12.3-6.8-3.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m747.1 847.4l8.2-20.9 7.3 2.9-11.3 29-46.2-17.9 11-28.4 7.3 2.8-7.8 20.3 12.4 4.8 6.9-17.7 7.4 2.9-6.8 17.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m807.9 417.8c0 215.5-390.2 570.2-390.2 570.2 0 0-390.1-354.7-390.1-570.2 0-215.4 174.7-390.1 390.1-390.1 215.5 0 390.2 174.7 390.2 390.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m79.3 750.3l31.9-5.1 1.4 8.7-31.6 5c-6.9 1.1-9.3 6.2-8.4 11.4 0.8 5.1 4.5 9.2 11.5 8.1l31.6-5 1.3 8.7-31.9 5.1c-11.2 1.7-19.2-5.8-20.8-15.6-1.6-9.9 3.8-19.6 15-21.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m82.4 838.4l13.2-17.3-1.4-4.2-17.2 5.7-2.8-8.3 47-15.8 6.2 18.4c3.6 10.5-2.5 17.5-10 20-6.8 2.3-15.1 0.1-18.4-6.7l-13.3 18.1zm34.2-29.2l-15.4 5.2 2.8 8.4c2 5.9 6.2 7.2 10.4 5.7 4.3-1.4 6.9-5.2 5.4-9.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m106.1 859.2l4 7.8c-3.4 1.8-4.9 6.7-2.3 11.5 2.3 4.5 6.5 6 10 4.2 3.1-1.6 3.5-5.2 2.6-9.4l-1.4-6.3c-2.5-10.7 2.3-15.3 6.2-17.3 7.8-4.1 16.6 0 20.8 8.1 4.2 8 2.6 16.9-5.7 21.2l-4-7.7c3.6-1.9 4.8-6 2.7-10.1-2-3.8-6.2-5.6-9.6-3.8-1.2 0.7-3.6 2.4-2.3 8.1l1.2 6.1c1.7 7.9 0.9 15-6.1 18.7-8.1 4.2-16.9 0.3-21.4-8.4-4.9-9.3-2.2-18.8 5.3-22.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m173.2 902.3c6.5 8.8 2.8 17.3-3.6 22-6.4 4.8-15.5 5.7-22-3.1l-6.7-9.1-14.3 10.5-5.2-7.1 39.9-29.4zm-19.5 13.9c3.1 4.1 7.5 3.5 10.7 1.1 3.2-2.3 5.3-6.4 2.3-10.5l-6.5-8.9-13 9.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m174.9 978.1l4-21.5-3.2-3.1-12.7 12.9-6.2-6.2 34.7-35.3 13.9 13.6c7.9 7.8 5.6 16.7 0.1 22.4-5 5.1-13.4 6.9-19.5 2.3l-3.7 22.2zm17.4-41.5l-11.4 11.6 6.3 6.2c4.4 4.3 8.7 3.6 11.9 0.4 3.2-3.2 3.7-7.8 0.3-11.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m209.1 985.2l18.6-26.5 7.1 5-18.3 26.2c-4 5.8-2 11 2.3 14 4.3 3 9.9 3.1 13.9-2.6l18.4-26.2 7.2 5-18.6 26.5c-6.5 9.3-17.5 9.9-25.6 4.2-8.2-5.8-11.5-16.3-5-25.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m298 1000.3l7.9 3.7-21 44.9-7.2-3.4-3.8-38.6-14.1 30.2-8-3.7 21-44.9 7.5 3.5 3.7 38.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m312.6 1033.3c3.5-13.6 17.2-22.1 30.9-18.5 6.9 1.8 12.3 6.2 15.4 11.6l-7.6 3.8c-2.1-3.6-5.5-6.4-9.8-7.6-9-2.3-17.9 3.7-20.3 13-2.4 9.1 2.3 18.8 11.5 21.2 7.1 1.9 14.9-1 16.5-7.2l-13.7-3.6 1.8-7.1 23 6c-4.6 17.5-16.1 23.1-29.4 19.6-14.2-3.7-21.8-17.7-18.3-31.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m442 1067.5l0.1 7.5h-1.8c-5.4 0.1-9.3-2.1-10.9-5.8-2.5 4.1-7.6 6.6-13.5 6.7-9.5 0.1-15.6-5.8-15.8-14.1-0.1-6.6 3.9-11.5 8.7-13.4-3.5-1.4-6-5.5-6.1-10.5-0.1-7.5 5.7-13.2 14.2-13.4 5.2-0.1 9.9 2.3 12.6 5.9l-5.9 5.2c-1.3-2-3.8-3.3-6.4-3.3-3.5 0.1-6.2 2.5-6.2 6.2 0.1 3.9 3 6.7 7.9 6.6l7.5-0.1-0.1-5.3 7.9-0.1 0.1 5.4 6.1-0.1 0.1 6.4-6.1 0.1 0.2 7.8c0 5.3 2.5 8.4 5.9 8.3zm-15.4-8.9l-0.1-7-7.2 0.1c-6.6 0.1-10.9 3.8-10.8 9 0.1 4.6 3.4 7.5 8.3 7.4 5.9-0.1 9.8-3.9 9.8-9.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m488 1068.7l-9.8-48.6 8.6-1.8 9.8 48.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m522.7 1008.2c13.4-4.6 24.8 2.8 29.4 16.2 4.6 13.2 0.3 26-13.1 30.6l-18.4 6.4-16.2-46.8zm13.7 39.4c8.5-2.9 10.3-11.7 7.3-20.4-3.1-8.7-10-14.5-18.5-11.6l-10 3.5 11.1 32z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m584.7 1026.7l19.7-10.8 3.7 6.9-27.3 15-23.8-43.5 26.7-14.6 3.8 6.8-19.1 10.5 6.4 11.7 16.7-9.1 3.8 7-16.6 9.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m618.7 954.2l7-5.4 30.4 39.1-6.3 4.9-36.1-14.2 20.5 26.4-6.9 5.4-30.5-39.2 6.6-5 35.7 14.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m660.3 913.1l5.8 5.4-9.7 10.4 30.5 28.4-6 6.5-30.5-28.5-9.7 10.3-5.7-5.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m708.2 931.7l-39.9-29.4 5.2-7.1 39.9 29.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m699.9 852.2l6.8 3.8-7 12.3 36.2 20.7-4.3 7.6-36.3-20.6-7 12.3-6.8-3.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m747.1 847.4l8.2-20.9 7.3 2.8-11.3 29.1-46.2-18 11-28.3 7.3 2.8-7.8 20.3 12.4 4.8 6.9-17.7 7.4 2.9-6.8 17.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m807.9 417.8c0 215.5-390.2 570.2-390.2 570.2 0 0-390.1-354.7-390.1-570.2 0-215.4 174.7-390.1 390.1-390.1 215.5 0 390.2 174.7 390.2 390.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m727.6 765.5l7.7 1.7-3.1 13.8 40.7 9.2-2 8.6-40.7-9.2-3.1 13.8-7.6-1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m727.6 765.4l7.7 1.8-3.1 13.8 40.7 9.2-2 8.5-40.7-9.1-3.1 13.8-7.6-1.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp14)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp15)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp16)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp17)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp18)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp21)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp22)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp23)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp25)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp26)"
  }))))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m186.8 164.2c0 4.3-3.5 7.8-7.8 7.8-4.4 0-7.9-3.5-7.9-7.8 0-4.4 3.5-7.9 7.9-7.9 4.3 0 7.8 3.5 7.8 7.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m172.4 178.3c0 4.4-3.5 7.9-7.9 7.9-4.3 0-7.8-3.5-7.8-7.9 0-4.3 3.5-7.8 7.8-7.8 4.4 0 7.9 3.5 7.9 7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m127.5 371.7c0 10.2-8.3 18.5-18.5 18.5-10.2 0-18.5-8.3-18.5-18.5 0-10.2 8.3-18.5 18.5-18.5 10.2 0 18.5 8.3 18.5 18.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m756.6 371.7c0 10.2-8.3 18.5-18.5 18.5-10.2 0-18.5-8.3-18.5-18.5 0-10.2 8.3-18.5 18.5-18.5 10.2 0 18.5 8.3 18.5 18.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp29)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp30)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp31)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp32)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp33)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp34)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp35)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp36)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp37)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp38)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp39)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp40)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp41)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp42)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp43)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp44)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp45)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp46)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp47)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp48)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp49)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp50)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp51)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp52)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp53)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp54)"
  }))))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp55)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp56)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m570.8 239.9h-308.6l32.1-18c37.2-20.8 79.5-31.8 122.2-31.8 42.7 0 85 11 122.2 31.8zm-226-19.2h143.3c-46.1-15-97.2-15-143.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m617.7 595.4v-308.7l17.9 32.1c20.8 37.2 31.8 79.5 31.8 122.2 0 42.8-11 85-31.8 122.2zm19.2-226v143.3c7.5-23 11.4-47.2 11.4-71.6 0-24.4-3.9-48.6-11.4-71.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m215.3 595.4l-17.9-32.2c-20.8-37.2-31.8-79.4-31.8-122.2 0-42.7 11-85 31.8-122.2l17.9-32.1zm-19.2-226c-7.5 23-11.3 47.2-11.3 71.6 0 24.4 3.8 48.6 11.3 71.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m416.5 691.9c-42.7 0-85-10.9-122.2-31.7l-32.1-18h308.7l-32.2 18c-37.2 20.8-79.5 31.7-122.2 31.7zm-71.7-30.5c46.1 15 97.3 15 143.4 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m186.8 164.1c0 4.4-3.5 7.9-7.8 7.9-4.4 0-7.9-3.5-7.9-7.9 0-4.3 3.5-7.8 7.9-7.8 4.3 0 7.8 3.5 7.8 7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m172.4 178.3c0 4.3-3.5 7.9-7.9 7.9-4.3 0-7.8-3.6-7.8-7.9 0-4.3 3.5-7.8 7.8-7.8 4.4 0 7.9 3.5 7.9 7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m134.2 486.3l2.1 10.4-51.8 10.5-2.2-10.4 21.1-4.3-3.9-19.3-21.1 4.2-2.1-10.4 51.9-10.5 2.1 10.4-21.4 4.4 3.9 19.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m133.4 538.6l3.6 9.3-33.5 13-3.6-9.4 4.8-1.9c-4.3-0.9-8.2-4.3-9.9-8.8-3.6-9.3 0.9-18.9 11.3-22.9 10.4-4 20.2-0.1 23.9 9.5 1.7 4.3 1.5 9.3-1.1 12.9zm-16.8 6.2c5-2 7.3-7.5 5.5-12.2-1.9-4.9-7.3-7-12.2-5.1-4.7 1.8-7.4 7.1-5.5 12 1.8 4.7 7.4 7.1 12.2 5.3zm20.3-31.2c2.8-1 5.8 0.5 6.8 3.3 1.1 2.7-0.1 5.8-2.9 6.8-2.8 1.1-5.7-0.3-6.7-3.1-1.1-2.8 0.1-5.9 2.8-7zm5.8 14.8c2.7-1 5.7 0.5 6.8 3.3 1 2.8-0.2 5.8-2.9 6.9-2.8 1.1-5.7-0.3-6.8-3.1-1.1-2.8 0.1-6 2.9-7.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m154.9 581.8l-9.5 2.5c0-2.4-0.7-4-1.3-5.1-2.5-4.5-8.4-5.3-17.4-0.4l-10.8 5.9-4.8-8.8 31.5-17.2 4.7 8.7-6.7 3.7c6.2-1.1 10.5 1.2 12.6 5.1 0.9 1.7 1.7 3.7 1.7 5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m129.8 608.1l29.8-20 5.6 8.3-29.7 20zm39.2-28c2.8-1.9 6.6-0.9 8.5 1.9 2 3 1.4 6.8-1.4 8.7-2.8 1.8-6.6 1-8.6-1.9-1.9-2.9-1.3-6.8 1.5-8.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m193.2 616.2c-3.6-4.5-7.2-4-10.6-1.3l-2.1 1.6 4.9 6.1-6.2 4.9-4.8-6.1-21.9 17.5-6.3-7.8 21.9-17.5-4.3-5.3 6.2-4.9 4.2 5.3 2-1.6c8.4-6.8 16.6-6.3 23 1.7l2.7 3.3-7.3 5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m209.2 647.7l-8.4 5c-0.7-2.3-1.9-3.7-2.7-4.5-3.6-3.7-9.6-2.8-16.8 4.3l-8.8 8.7-7-7.2 25.5-25.2 7 7.1-5.5 5.4c5.7-2.7 10.4-1.7 13.5 1.5 1.4 1.4 2.7 3.1 3.2 4.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m235.9 668.9l8 6.2-22 28.3-8-6.1 3.2-4.1c-4.2 1.4-9.3 0.5-13.1-2.5-7.8-6-8.9-16.6-2.1-25.4 6.8-8.8 17.3-10.5 25.4-4.2 3.7 2.8 6.1 7.2 5.7 11.6zm-11.3 14c3.4-4.3 2.4-10.2-1.5-13.3-4.1-3.2-9.9-2.2-13.1 2-3 3.9-2.7 9.8 1.5 13.1 4 3.1 10 2.3 13.1-1.8zm5.9-36.2c3.1-4.1 8.9-4.7 12.9-1.6 4.1 3.1 4.8 8.9 1.7 12.9-3.1 4-8.8 4.7-12.9 1.5-4-3.1-4.8-8.8-1.7-12.8zm3.5 2.8c-1.6 2-1.1 4.9 0.9 6.5 2.1 1.6 5.1 1.4 6.7-0.6 1.7-2.2 1.1-5.2-0.9-6.8-2-1.6-5-1.2-6.7 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m276.8 712.8l-9.5 17.2-8.8-4.9 9.2-16.7c2.8-4.9 1-8.8-2-10.4-3.1-1.8-8-2.3-11.1 3.5l-9.1 16.4-8.8-4.9 17.3-31.3 8.8 4.8-2.9 5.4c3.7-3.5 9.7-2.7 12.8-1 8.2 4.6 9.4 12.5 4.1 21.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m338 755.8l-12-3.7-7.5-18.5-4.5 14.8-9.6-2.9 16.2-52.9 9.6 2.9-8.9 29.2 11.9-7.9 12.3 3.8-18 11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m347.9 739.7c1.9-11.2 12-17.2 22.1-15.5 10.1 1.6 17.8 10.5 16 21.7-1.9 11.2-12 17.1-22.1 15.5-10.1-1.7-17.8-10.6-16-21.7zm28 4.6c0.9-5.6-2.5-10.1-7.4-10.9-4.9-0.8-9.6 2.4-10.5 8-0.9 5.4 2.5 9.9 7.4 10.7 4.9 0.8 9.6-2.4 10.5-7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m456.4 744.5l0.5 19.6-10.1 0.3-0.5-19.4c-0.2-5.6-3.1-7.9-6.7-7.8-4.3 0-6.9 3.2-6.8 9.9l0.5 17.6-10.1 0.3-0.5-19.2c-0.1-5.7-3.1-8.1-6.5-8-3.6 0.1-7.2 2.2-7 8.6l0.4 18.9-10 0.2-0.9-35.8 10-0.2 0.2 7c0.6-5.4 5.9-8.1 9.9-8.2 5.3-0.1 9.5 2.3 11.7 6.8 2.5-5.3 8.1-7.3 11.8-7.4 9-0.2 13.8 6 14.1 16.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m527.5 728.3l4.8 19-9.9 2.5-4.7-18.7c-1.4-5.5-4.8-7.1-8.2-6.2-4.2 1-6.1 4.6-4.5 11.1l4.3 17.1-9.7 2.5-4.7-18.6c-1.4-5.5-4.8-7.2-8.1-6.4-3.5 0.9-6.6 3.8-5 10l4.6 18.3-9.7 2.5-8.8-34.8 9.8-2.4 1.7 6.7c-0.6-5.3 3.9-9.1 7.9-10.1 5.1-1.3 9.7 0.2 12.9 4 1.2-5.7 6.2-8.8 9.8-9.8 8.7-2.1 14.8 2.9 17.5 13.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m575.2 712.1l-24.5 11.3c2.7 3.4 6.8 4.2 11.1 2.2 3.4-1.5 5.9-4.5 6.9-7.8l7.7 3c-1.1 5.5-5.7 10.5-11.4 13.2-10 4.6-20.6 0.9-25.2-9.2-4.9-10.5 0.1-20.8 9.4-25.1 9.4-4.3 20-1.1 24.6 8.9 0.4 0.9 0.9 2 1.4 3.5zm-11.7-1.8c-2.1-3.7-6.3-4.7-10.5-2.8-3.7 1.7-6.1 5.1-5 9.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m597.4 674l3.1 9.3c-2.4 0.2-4 1-5.1 1.7-4.3 2.7-4.8 8.7 0.6 17.3l6.5 10.4-8.5 5.4-19-30.5 8.5-5.2 4.1 6.5c-1.5-6.2 0.6-10.5 4.3-12.9 1.7-1 3.7-1.9 5.5-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m672.2 627.9l14 13.8-7.1 7.2-13.8-13.6c-4-3.9-7.7-3.5-10.2-1-3.1 3-2.8 7.1 1.9 11.8l12.6 12.4-7.1 7.2-13.6-13.5c-4.1-4-7.9-3.7-10.2-1.3-2.6 2.6-3.7 6.6 0.8 11.2l13.4 13.2-7 7.2-25.5-25.2 7.1-7.2 4.9 4.9c-3.2-4.2-1.3-9.8 1.5-12.7 3.8-3.8 8.4-4.9 13.2-3.2-1.9-5.6 0.7-10.8 3.4-13.5 6.3-6.4 14.1-5.2 21.7 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m682.4 584.2l5.6-8.3 29.8 19.9-5.6 8.3-4.2-2.8c1.7 4 1.1 9.2-1.6 13.2-5.5 8.2-15.9 10.1-25.2 3.9-9.2-6.2-11.7-16.5-6-25 2.6-3.9 6.8-6.6 11.2-6.5zm14.7 10.2c-4.5-3-10.3-1.6-13.1 2.5-2.9 4.3-1.5 10 2.9 12.9 4.1 2.8 10 2 12.9-2.4 2.9-4.3 1.6-10.1-2.7-13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m702.8 546.3l7 3.5-3.3 6.8 25.2 12.2-4.4 9.1-25.2-12.3-2.9 5.9-7-3.4 2.8-5.9-11.7-5.7 4.4-9 11.7 5.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m738.3 512.7l-9.1 25.4c4.3 0.4 7.8-2 9.4-6.5 1.2-3.4 0.8-7.3-0.8-10.3l7.5-3.5c3.1 4.7 3.6 11.5 1.4 17.4-3.7 10.4-13.7 15.4-24.1 11.7-10.9-3.9-14.8-14.7-11.4-24.3 3.5-9.7 13.2-15.1 23.5-11.4 1 0.3 2.1 0.8 3.6 1.5zm-9.5 7.1c-4.1-1.1-7.8 1.2-9.3 5.5-1.4 3.9-0.7 7.9 3.5 10.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m743.6 464.7l19.3 3.8-2 9.9-18.8-3.7c-5.4-1.1-8.6 1.7-9.3 5.1-0.7 3.5 0.4 8.3 6.8 9.6l18.4 3.6-1.9 9.9-35.2-7 1.9-9.9 6 1.2c-4.5-2.4-5.5-8.4-4.8-11.9 1.8-9.2 9.1-12.7 19.6-10.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m704.7 298l-20.4-34.4c-5.5 4.9-6 11.6-2.1 18.3 2.9 4.7 7.7 8.1 12.8 8.6l-1.2 10.7c-8.9-0.2-17.2-6-22-14.1-7.8-13.2-4.2-28.9 9.6-37.2 14.2-8.4 29.6-3.2 37.2 9.5 7.5 12.7 4.3 28-9.6 36.3-1.2 0.7-2.7 1.5-4.3 2.3zm1.3-15.3c5.7-4.3 6.5-11.2 2.8-17.4-3.5-5.9-9.3-9-16.8-6.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s6",
    d: "m164.3 235.5l24.1 16.1-7.1 10.7-23.4-15.6c-6.8-4.6-13.3-2.9-16.5 1.9-3.2 4.8-4.4 12.8 3.8 18.3l22.8 15.3-7.1 10.6-42.9-28.6 7.1-10.7 6.8 4.5c-4-5.8-1.9-14.2 1-18.6 7.4-11 18.9-12.2 31.4-3.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m196.9 170.6l9.5-8.6 34.7 38.3-9.5 8.6-5.4-6c1.2 6.5-1.3 13.9-6.8 18.8-10.3 9.3-26 8.4-36.8-3.5-10.4-11.5-10.3-27.2 0.6-37 5.2-4.7 12.4-7 18.5-5.3zm17.2 19.3c-6-6.6-15.6-6.4-21.3-1.3-6.1 5.6-6.2 14.9-0.6 21.1 5.5 6.1 14.9 7.1 21.1 1.4 5.9-5.3 6.6-14.9 0.8-21.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s6",
    d: "m265.9 125.7l3.9 11.8c-3.4 0.2-5.9 1.2-7.5 2.1-7.3 4.2-7.1 13.8 0 26.4l9 15.6-11.2 6.4-25.7-44.8 11.2-6.4 5.4 9.6c-1.8-8.8 1.2-14.9 6.8-18.1 2.7-1.5 5.9-2.6 8.1-2.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s6",
    d: "m322.3 103.7l13.2-4.4-4.2 55.9-11.2 3.7-36.8-42.1 13.1-4.4 24.2 29.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m400.1 90.3l12.7-1.2 4.9 51.4-12.7 1.2-0.8-8c-2.9 6-9.4 10.3-16.7 11-13.8 1.4-25.9-8.7-27.4-24.7-1.5-15.5 8-28 22.6-29.3 7-0.7 14.1 1.7 18 6.8zm2.3 25.7c-0.9-8.8-8.7-14.4-16.3-13.7-8.3 0.8-13.9 8.2-13.1 16.5 0.8 8.2 7.7 14.6 16.1 13.8 7.9-0.8 14.1-8 13.3-16.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s6",
    d: "m482.3 95.6l-4 11.8c-2.8-1.9-5.4-2.6-7.2-2.8-8.4-1-14 6.8-15.8 21.2l-2.1 17.9-12.9-1.6 6.3-51.3 12.7 1.6-1.3 11c3.8-8.3 9.8-11.3 16.2-10.5 3.1 0.3 6.3 1.4 8.1 2.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m495.3 123.8c5.2-15.5 20.7-21.6 34.6-16.9 14 4.7 22.7 18.9 17.5 34.4-5.2 15.5-20.8 21.7-34.8 17-13.9-4.7-22.5-19-17.3-34.5zm39.8 13.4c2.9-8.4-1.4-16.5-9-19-7.5-2.6-15.7 1.3-18.5 9.7-2.9 8.6 1.3 16.6 8.8 19.1 7.6 2.5 15.8-1.2 18.7-9.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s6",
    d: "m613.3 149.3l-8.4 9.2c-1.8-2.9-3.9-4.5-5.5-5.5-7.2-4.2-15.5 0.7-22.9 13.1l-9.1 15.6-11.2-6.6 26.2-44.5 11.1 6.5-5.6 9.5c6.7-6 13.5-6.4 19-3.1 2.7 1.5 5.2 3.8 6.4 5.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s6",
    d: "m597.5 192.7c2.9-3.7 8.1-4.1 11.6-1.3 3.7 2.8 4.7 7.9 1.8 11.7-2.9 3.7-8.1 4.1-11.8 1.3-3.6-2.8-4.5-7.9-1.6-11.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s6",
    d: "m632.1 209.1l8.2 8.8c-2.6 2.5-2.9 7 0.8 10.9 3.5 3.8 7.6 4.5 10.1 2.2 2.1-2 1.5-4.5-0.5-7.9l-3.4-6.2c-5.6-10.6-3.1-17.1 1.6-21.5 5.9-5.5 16.7-4.7 24.4 3.6 6.3 6.7 10 17.4 1.5 25.2l-8.4-9c2.6-2.4 2-6.2-0.5-8.9-2.7-2.9-6.3-3.3-8.6-1.2-2 1.9-1.4 4.8 0.2 7.4l4 7.6c5.8 10.5 1.9 17-1.6 20.3-7.7 7.1-19 3.4-26.2-4.3-7-7.5-9.5-19.3-1.6-27z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtQrFrame);
export default __webpack_public_path__ + "static/media/ttQRFrame.e14208f622308f14f1851b3becd216c1.svg";
export { ForwardRef as ReactComponent };